/**
 * @generated SignedSource<<6012ff13f6baecb7dff2afec5a82941f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdatevendorpayoutchargeapprovalsPayload",
    "kind": "LinkedField",
    "name": "updatevendorpayoutchargeapprovals",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "integer",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PayoutDetailUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PayoutDetailUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4a45c5c4dd0588698e98770c3f5da1cb",
    "id": null,
    "metadata": {},
    "name": "PayoutDetailUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation PayoutDetailUpdateMutation(\n  $input: UpdatevendorpayoutchargeapprovalsInput!\n) {\n  updatevendorpayoutchargeapprovals(input: $input) {\n    integer\n  }\n}\n"
  }
};
})();

node.hash = "bebd975fe340cecd8c825592d61f0a5c";

module.exports = node;
